import { Calculator } from "/react4xp/parts/price-calculator/PriceCalculator";

export default (props) => <Calculator {...props} />
